import { SUBMIT_FIRST_LOGIN_ASYNC } from './constants'

export const submitFirstLogin = (data) => ({
  type: SUBMIT_FIRST_LOGIN_ASYNC.INITIATE,
  payload: { data },
})
export const submitFirstLoginSuccess = (data) => ({
  type: SUBMIT_FIRST_LOGIN_ASYNC.SUCCESS,
  payload: { data },
})
export const submitFirstLoginError = (error) => ({
  type: SUBMIT_FIRST_LOGIN_ASYNC.ERROR,
  error,
})

export default {
  submitFirstLogin,
}
